module.exports = __webpack_public_path__ + "static/media/lorelai-miss.9f6f3195.wav";